module.exports = __webpack_public_path__ + "static/media/bzr-collage-1.a3f7d7d5.png";